import axios from "axios";
import Constant from "../services/Constant";
import { APILIST } from '../Config/ApiList';
const baseUrl = {
  url: Constant.BASE_URL,
};
export const EMAIL_VERIFY = (token) => {
  const f = new FormData();
  f.append("ev_token", token);
  return axios.post(baseUrl.url + APILIST.EMAIL_VERIFY, f);
};
export const VERIFY_TOKEN = (token) => {
  const f = new FormData();
  f.append("fp_token", token);
  return axios.post(baseUrl.url + APILIST.CHECK_TOKEN, f);
};
export const CHANGE_PASSWORD = ({ fp_token, password }) => {
  const f = new FormData();
  f.append("fp_token", fp_token);
  f.append("password", password);
  return axios.post(baseUrl.url + APILIST.CHANGE_PASSWORD, f);
};
